import axios from './configAxiosOrganizations';

export const getOrgContracts = async (org_id) => {
	return await axios.get(`/${org_id}/contract/list/`);
};
